import {
  ColumnType,
  RIGHT_ALIGN_CLASS,
  changeView,
  percentageView,
  textView,
  titleViewWithLink,
  weightView,
} from "./functions";

export const tenantDetailsColumns: ColumnType[] = [
  {
    label: "entities:customer",
    name: "name",
    getView: titleViewWithLink,
  },
  {
    label: "circularityLabels:recyclingRate",
    name: "recyclingRate",
    getView: (value) => percentageView(value, " %", RIGHT_ALIGN_CLASS),
  },
  {
    label: "statisticsLabels:changeSincePrevPeriod",
    name: "percentageChange",
    getView: (value) => changeView(value, "percent", RIGHT_ALIGN_CLASS),
  },
  {
    label: "entities:wasteTypes",
    name: "wasteTypes",
    getView: (value) => textView(value, RIGHT_ALIGN_CLASS),
  },
  {
    label: "statisticsLabels:regResidualWasteWeight",
    name: "residualWaste",
    getView: (value) => weightView(value, RIGHT_ALIGN_CLASS),
  },
  {
    label: "statisticsLabels:regTotalWeight",
    name: "totalWeight",
    getView: (value) => weightView(value, RIGHT_ALIGN_CLASS),
  },
];

export const expandedTenantDetailsColumns: ColumnType[] = [
  {
    label: "genericLabels:wasteType",
    name: "wasteType",
    getView: (value) => textView(value, "block leading-[48px]"),
  },
  {
    label: "circularityLabels:wasteCode",
    name: "wasteCode",
    getView: (value) => textView(value, RIGHT_ALIGN_CLASS),
  },
  {
    label: "statisticsLabels:registeredNoThrows",
    name: "throws",
    getView: (value) => textView(value, RIGHT_ALIGN_CLASS),
  },
  {
    label: "statisticsLabels:amount",
    name: "totalWeight",
    getView: (value) => weightView(value, "justify-end"),
  },
  {
    label: "statisticsLabels:share",
    name: "share",
    getView: (value) => percentageView(value, " %", "justify-end pr-2"),
  },
];
